const {
  NODE_ENV,
  VUE_APP_NAME,
  VUE_APP_GTM_ID,
  VUE_APP_GTM_ENABLED,
  VUE_APP_DEBUG,
  VUE_APP_API_URL_TRACKING,
  VUE_APP_COMPANY_NAME,
} = process.env;

export const ENVIRONMENT = NODE_ENV;
export const APP_NAME = VUE_APP_NAME;
export const APP_GTM_ID = VUE_APP_GTM_ID;
export const APP_GTM_ENABLED = VUE_APP_GTM_ENABLED === 'TRUE';
export const APP_DEBUG = VUE_APP_DEBUG === 'TRUE';
export const APP_API_URL_TRACKING = VUE_APP_API_URL_TRACKING;
export const APP_COMPANY_NAME = VUE_APP_COMPANY_NAME;
